export default {
  deepMerge,
  isEmpty,
}

// https://stackoverflow.com/a/34749873/7407846
function deepMerge(target, ...sources) {
  if (!sources.length) return target
  const source = sources.shift()

  if (_isObject(target) && _isObject(source)) {
    for (const key in source) {
      if (_isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} })
        deepMerge(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return deepMerge(target, ...sources)
}

function isEmpty(obj) {
  return Object.keys(obj).length === 0
}

function _isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item))
}
